/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import { resetPasswordApiMessages } from "~/features/forgotPassword/constants";
import ForgotPasswordApi from "~/features/forgotPassword/ForgotPasswordApi";
import {
  PostForcedPasswordResetRequestBody,
  PostForgotPasswordRequestBody,
  PostResetPasswordRequestBody,
} from "~/features/forgotPassword/types";
import getAsyncThunkError from "~/utils/errors/getAsyncThunkError";

export const sendForgotPasswordAsync = createAsyncThunk(
  "forgotPassword/forgotPassword",
  async (data: PostForgotPasswordRequestBody) => {
    await ForgotPasswordApi.postForgotPassword(data);

    return data.email;
  },
);

export const resetPasswordAsync = createAsyncThunk(
  "forgotPassword/resetPassword",
  async (data: PostResetPasswordRequestBody, thunkAPI) => {
    try {
      await ForgotPasswordApi.postResetPassword(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(getAsyncThunkError(error, resetPasswordApiMessages));
    }
  },
);

export const sendForcedPasswordResetAsync = createAsyncThunk(
  "forgotPassword/weakPasswordReset",
  async (data: PostForcedPasswordResetRequestBody) => {
    return await ForgotPasswordApi.postForcedPasswordReset(data);
  },
);
